const SvgIcon = ({ size = '24', color = '#fff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={size}
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    version="1.1"
    viewBox="0 0 21.743 24"
  >
    <path
      fill={color}
      fillOpacity="1"
      stroke="none"
      strokeWidth="2.185"
      d="M10.871 0C9.203 0 7.436 1.236 7.24 3.304l.002.002-.004.006C7.145 4.358 6.11 4.952 5.158 4.51l-.01-.004c-1.886-.853-3.833.057-4.665 1.498s-.649 3.584 1.033 4.791l.01.007c.86.602.86 1.794 0 2.396l-.008.007C-.167 14.41-.35 16.555.483 17.997c.833 1.441 2.78 2.354 4.667 1.498l.01-.006c.952-.444 1.987.153 2.08 1.199v.006C7.435 22.762 9.202 24 10.87 24s3.438-1.238 3.635-3.306v-.006c.092-1.046 1.125-1.643 2.076-1.2l.01.007c1.887.856 3.835-.057 4.668-1.498s.65-3.587-1.035-4.793l-.008-.007c-.86-.603-.86-1.794 0-2.396l.008-.007c1.684-1.206 1.868-3.35 1.035-4.79-.833-1.443-2.78-2.355-4.667-1.499l-.01.004c-.952.444-1.985-.151-2.077-1.197v-.008C14.309 1.236 12.539 0 10.87 0m0 2.185c.731 0 1.361.307 1.458 1.326v-.007c.22 2.487 2.912 4.04 5.175 2.986l-.008.004c.928-.421 1.509-.03 1.873.602.365.63.413 1.329-.416 1.923l.009-.007c-2.043 1.434-2.043 4.542 0 5.976l-.009-.007c.83.594.781 1.292.416 1.923-.364.631-.945 1.021-1.873.6l.008.004c-2.263-1.054-4.955.5-5.175 2.988v-.009c-.097 1.02-.727 1.328-1.458 1.328-.73 0-1.36-.309-1.457-1.328-.226-2.482-2.917-4.033-5.178-2.979l.011-.004c-.928.421-1.509.031-1.874-.6-.364-.63-.412-1.329.417-1.923l-.009.007c2.043-1.434 2.043-4.542 0-5.976l.009.007c-.828-.594-.779-1.29-.414-1.921.364-.63.944-1.022 1.871-.602l-.01-.006c2.256 1.051 4.937-.492 5.17-2.967l.007-.012c.097-1.02.727-1.326 1.457-1.326"
      color="#000"
      opacity="1"
    ></path>
    <path
      fill={color}
      fillOpacity="1"
      stroke="none"
      strokeWidth="2.185"
      d="M10.871 7.63c-2.4 0-4.37 1.97-4.37 4.37s1.97 4.37 4.37 4.37 4.371-1.97 4.371-4.37-1.97-4.37-4.37-4.37m0 2.185c1.22 0 2.186.965 2.186 2.185s-.966 2.185-2.186 2.185A2.17 2.17 0 0 1 8.686 12c0-1.22.966-2.185 2.185-2.185"
      color="#000"
      opacity="1"
    ></path>
  </svg>
);

export default SvgIcon;
